import React from 'react';
import Listing from '../Listing/Listings';

const CompanyListing = () => {
    return (
        <Listing type="companies" />
    )
}

export default CompanyListing;